import React, { Fragment, useEffect, useState } from 'react';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import BrexitComplaintsDataComponent from '../components/BrexitComplaintsDataComponent';
import BrexitComplaintsDataSheet from '../components/BrexitComplaintsDataSheet';
import { trackLink, trackPage } from '../../lib/analytics-helper';
import { getComplaintsData } from '../../../jsV2/helpers/twHelper';

const complaintDataSheetTitle = 'Complaint Data Sheet';
const complaintsData = getComplaintsData();

function BrexitComplaintsDataContainer() {
  const [isComplaintDataSheetOpen, setIsComplaintDataSheetOpen] = useState(false);
  const openComplaintDataSheet = () => {
    trackLink({ id: 'complaintsDataSheetOpen', link: 'smarthelp-complaints-data-sheet-clicked|open' });
    setIsComplaintDataSheetOpen(true);
  };
  const closeComplaintDataSheet = () => {
    trackLink({ id: 'complaintsDataSheetClose', link: 'smarthelp-complaints-data-sheet-clicked|close' });
    setIsComplaintDataSheetOpen(false);
  };

  useEffect(() => {
    trackPage({ id: 'complaintsDataPanel', link: 'smarthelp-complaints-data' });
  }, []);

  const renderComplaintsDataSection = () => {
    return <BrexitComplaintsDataComponent openSheetEvent={openComplaintDataSheet} />;
  };

  const renderComplaintsDataSheet = () => {
    return (
      <BrexitComplaintsDataSheet
        complaintDataSheetTitle={complaintDataSheetTitle}
        isComplaintDataSheetOpen={isComplaintDataSheetOpen}
        handleSheetClose={closeComplaintDataSheet}
      />
    );
  };

  const complaintsDataTable = _get(complaintsData, 'table');
  if (_isEmpty(complaintsData) || _isEmpty(complaintsDataTable)) return null;

  return (
    <Fragment>
      {renderComplaintsDataSection()}
      {renderComplaintsDataSheet()}
    </Fragment>
  );
}

export default BrexitComplaintsDataContainer;
